import cx from 'classnames'
import React from 'react'

import { LOADING_TEXT } from '../../constants'

import * as skeletonStyles from '../../skeleton.module.css'
import * as styles from './subtitle.module.css'

interface SubtitleProps {
  isPending?: boolean
  className?: string
}

const Subtitle: React.FC<SubtitleProps> = ({ children, isPending = false, className = '' }) => (
  <p
    className={cx(styles.subtitle, skeletonStyles.base, { [skeletonStyles.active]: isPending }, className)}
    children={isPending ? LOADING_TEXT : children}
  />
)

export default Subtitle
